import {
    createStyles,
    Grid,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React from "react";
import Moment from "react-moment";
import Constants from "../../../models/utility/Constants";

type AuditTimestampsProps = WithStyles<typeof styles> & {
    createdBy?: string;
    createdOn?: string;
    modifiedBy?: string;
    modifiedOn?: string;
};
const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const styles = () =>
    createStyles({
        auditDetail: { fontWeight: "bold" }
    });

function AuditTimestamps(props: AuditTimestampsProps) {
    const classes = props.classes;

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={6}>
                <WhiteTextTypography variant="caption" display="block">
                    Created By:{" "}
                    <span className={classes.auditDetail}>
                        {props.createdBy}
                    </span>
                </WhiteTextTypography>
                <WhiteTextTypography variant="caption" display="block">
                    Created On:&nbsp;
                    <Moment
                        className={classes.auditDetail}
                        date={props.createdOn}
                        format={Constants.DateFormatAudit}
                        tz={Constants.TimeZone}
                    />
                </WhiteTextTypography>
            </Grid>
            <Grid item={true} xs={6}>
                <WhiteTextTypography variant="caption" display="block">
                    Modified By:{" "}
                    <span className={classes.auditDetail}>
                        {props.modifiedBy}
                    </span>
                </WhiteTextTypography>
                <WhiteTextTypography variant="caption" display="block">
                    Modified On:&nbsp;
                    <Moment
                        className={classes.auditDetail}
                        date={props.modifiedOn}
                        format={Constants.DateFormatAudit}
                        tz={Constants.TimeZone}
                    />
                </WhiteTextTypography>
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(AuditTimestamps);
